import { createContext } from 'react';

// What the V2 pages share: the colour mode and how to switch it.
export const V2Context = createContext({ mode: 'dark', toggleMode: () => {} });
